var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.875 0.5C11.4844 0.5 12 1.01562 12 1.625C12 2 11.8125 2.32812 11.5312 2.53906L6.44531 6.35938C6.16406 6.57031 5.8125 6.57031 5.53125 6.35938L0.445312 2.53906C0.164062 2.32812 0 2 0 1.625C0 1.01562 0.492188 0.5 1.125 0.5H10.875ZM5.08594 6.96875C5.625 7.36719 6.35156 7.36719 6.89062 6.96875L12 3.125V8C12 8.84375 11.3203 9.5 10.5 9.5H1.5C0.65625 9.5 0 8.84375 0 8V3.125L5.08594 6.96875Z",
    fill: "#D6D8E1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageIcon);
export default __webpack_public_path__ + "static/media/message-icon.5b936f34cf1811f58100c57e54ddf354.svg";
export { ForwardRef as ReactComponent };